import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'silos'
const verb = 'get'

export default class OspreySiloSearch extends BaseAction {
    constructor(dataKey) {
        const id = '05e2d88d-48ca-4db6-9632-f2d6279ff842'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    search(params) {
        this.params = Object.assign({
            fields: 'id,city,name,ownerName,state,status'
        }, params)

        return fetchContentIfNeeded(this)
    }
}



// WEBPACK FOOTER //
// src/actions/osprey-api/silos/silos-search.js